﻿import React from 'react';
import CallTrackApi from '../Activity_Track/CallTrackApi';
function Elsscalculator() {
    function iframe() {
        return {
            __html: '<iframe src="elss-calculator.html" title="ELSS Calculator" width="100%" height="650px" style="border:0; overflow:hidden"></iframe>'
        }
    }
    CallTrackApi("Elss Calculator",window.location.href);

    return (
        <>
            <div>
                <div dangerouslySetInnerHTML={iframe()} />
            </div>
        </>
    );
}
export default Elsscalculator;